{
  "buttons": {
    "save": "Save"
  }
}
